import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";
import { useStateLocalStorage } from "@dotlegal/dotlegal-ui-components";
import { AuditType } from "./AuditTab.types";

export const auditTabLocalStorageKey = "auditTab";

export default function useAuditTab() {
    const { permissions } = useUserContext();

    const isExternalAuditsEnabled = permissions.canManageAuditGroups;
    const isInternalAssessmentsEnabled = permissions.canManageInternalAssessment;

    const defaultAuditType = isExternalAuditsEnabled ? AuditType.External : AuditType.Internal;

    const disableSwitch = !isInternalAssessmentsEnabled || !isExternalAuditsEnabled;

    const [selectedAuditType, setSelectedAuditType] = useStateLocalStorage(auditTabLocalStorageKey, defaultAuditType);

    return {
        selectedAuditType,
        setSelectedAuditType,
        disableSwitch,
    };
}
